export default "__VITE_ASSET__45ca6acb__"